/* eslint-disable no-restricted-imports */
import { useEffect } from 'react';
import { loadDirectCampaignsAsync } from '../../../../data-layer/direct/actions';
import {
    selectDirectCampaigns,
    selectDirectCampaignsLoading,
} from '../../../../data-layer/direct/selectors';
import { useDispatch } from '../../../../data-layer/useDispatch';
import { useSelector } from '../../../../data-layer/useSelector';
import { toDirectCampaignUI } from '../../../../mappers/direct/toCampaignUI';
import { useCurrentUser } from '../../../../routing/users/useCurrentUser';
import { setCookie } from '../../../../utils/setCookie';

export const useDirectCompanies = () => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const directCompanies = useSelector(selectDirectCampaigns);
    const isLoading = useSelector(selectDirectCampaignsLoading);

    useEffect(() => {
        if (currentUser?.profile?.publicId && !isLoading && directCompanies === undefined) {
            dispatch(loadDirectCampaignsAsync(currentUser.profile.id));
        }
    }, [currentUser, dispatch, isLoading, directCompanies]);

    // если есть кампания, то чистим токен
    useEffect(() => {
        if (directCompanies?.length) {
            setCookie('direct_access_token', '');
        }
    });

    return {
        directCompanies: directCompanies ? toDirectCampaignUI(directCompanies) : undefined,
        isLoading,
    };
};
